import { months } from './enum';

export function formatData(data) {
  let formatedData = new Date(data);

  return formatedData.getDate() + " " +months[formatedData.getMonth()+1] + " " + formatedData.getFullYear();
}

export function formatDataWithHour(data) {
  let formatedData = new Date(data);

  return formatedData.getDate() + " " +months[formatedData.getMonth()+1] + " " + formatedData.getFullYear() + " " + formatAMPM(formatedData);
}

function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export function calculateDate(date) {
  var birthday = +new Date(date);
  return ~~((Date.now() - birthday) / (31557600000));
}

export function diffBetweenDateInSeconds(expiration) {
  const startDate = new Date();
  const endDate = new Date(expiration);
  endDate.setHours(endDate.getHours() + 2);
  return (endDate.getTime() - startDate.getTime()) / 1000;
}

export function formatDateToDefaultUS(date){
  const data = new Date(date),
      dia  = data.getDate().toString().padStart(2, '0'),
      mes  = (data.getMonth()+1).toString().padStart(2, '0'),
      ano  = data.getFullYear();
  return ano+"-"+mes+"-"+dia;
}
